import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { AnalyticsService } from '@se-po/shared-data-access-services'
import { environment } from '@se-po/shared-environments'
import { Subscription } from 'rxjs'
import { SeFeModalButton, SeFeModalComponent } from 'se-fe-modal'
import { Persona } from '../../models'
import { PersonaService } from '../../services'

@Component({
  selector: 'app-profile-merge-modal',
  templateUrl: './profile-merge-modal.component.html'
})
export class ProfileMergeModalComponent implements OnDestroy {
  @Input() public keepPersona: Persona
  @Input() public description: string
  @Output() public successfulMerge: EventEmitter<void> = new EventEmitter<void>()
  @ViewChild('modal') public modal: SeFeModalComponent
  @ViewChild('modal2') public modal2: SeFeModalComponent

  public avatarBackgroundImage: string
  public mergeError = ''
  public options: SeFeModalButton[] = []
  public options2: SeFeModalButton[] = []

  private _mergePersona: Persona
  private _subscriptions: Subscription[] = []

  constructor(private translateService: TranslateService,
    private personaService: PersonaService,
    private analyticsService: AnalyticsService) {
    // noop
  }

  @Input()
  public get mergePersona(): Persona { return this._mergePersona }
  public set mergePersona(mergePersona: Persona) {
    this._mergePersona = mergePersona
    this.setOptions()
    this.setAvatarBackgroundImage()
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach(subscription => subscription.unsubscribe())
    this._subscriptions.length = 0
  }

  public open() {
    this.mergeError = ''
    this.modal.open(null)
  }

  public openModal2() {
    this.modal2.open(null)
  }

  private setOptions(): void {
    this.options = [
      {
        label: this.translateService.instant('MODAL.cancel'),
        action: () => this.modal.close()
      },
      {
        primary: true,
        label: this.translateService.instant(
          'PERSONAS.MERGE_CONFIRMATION_MODAL.continue',
          { name: this.keepPersona?.firstLastSuffix || '' }),
        action: () => this.openModal2()
      }
    ]
    this.options2 = [
      {
        label: this.translateService.instant('MODAL.cancel'),
        action: () => this.modal2.close()
      },
      {
        primary: true,
        label: this.translateService.instant(
          'PERSONAS.MERGE_CONFIRMATION_MODAL.submit',
          { name: this.keepPersona?.firstLastSuffix || '' }),
        action: () => this.mergePersonas()
      }
    ]
  }

  private setAvatarBackgroundImage() {
    const mergePersonaImageUrl = this.mergePersona?.cropImage
    const defaultImageUrl = `${environment.uiThemes}/assets/latest/images/avatar.svg`
    const avatarBackgroundImageUrl = mergePersonaImageUrl || defaultImageUrl
    this.avatarBackgroundImage = 'url(' + avatarBackgroundImageUrl + ')'
  }

  private mergePersonas() {
    this.analyticsService.seEvent('ReviewDuplicates.Modal.MergeClick', 8)
    this._subscriptions.push(this.personaService.merge(this.keepPersona.id, this.mergePersona.id, this.description)
      .subscribe(_ => {
        this.successfulMerge.emit()
        this.modal2.close()
        this.modal.close()
      },
      err => {
        this.mergeError = err
        this.modal2.close()
      }))
  }

}
